import React, { useRef } from 'react';
import { useFormContext } from '../../components/FormContext';


const PoliceCheckSection = () => {
  const { 
    formData, 
    formErrors, 
    modifiedFields,
    setFieldValue,
    setFormErrors, 
    setFile,
    setModifiedFields
  } = useFormContext();
  const policeInputRef = useRef(null);
  
  const validatePDFFile = (field, e) => {
    
    const file = e.target.files[0];
    setFile('policeCheck', file);
    setModifiedFields(prev => new Set([...prev, field]));

    let error = null;
    if (!file) {
      
      error = `PDF file is required for your ${field.charAt(0).toUpperCase() + field.slice(1)}`;
      
    } else if ( file.type !== 'application/pdf') {
        
      error = `PDF file is only excepted for your ${field.charAt(0).toUpperCase() + field.slice(1)}`;
    } 
        
        
      

   
    
    if (error) {
      setFormErrors(prev => ({...prev, [field]: error}));
    } else {
      setFormErrors(prev => {
        const newErrors = {...prev};
        delete newErrors[field];
        return newErrors;
      });
    }
  };



  const validatePastDate = (field, e) => {
    const value = e.target.value;
    setFieldValue('policeCheckIssue', value);
    setModifiedFields(prev => new Set([...prev, field]));

    let error = null;
    if (!value) {
      error = `${field} is required`;
    } else {
        
      const selectedDate = new Date(value);
      const today = new Date();
        
    if (selectedDate > today) {
        error = `${field} cannot be in the future`;
      }
        
      
    }

    if (error) {
      setFormErrors(prev => ({...prev, [field]: error}));
    } else {
      setFormErrors(prev => {
        const newErrors = {...prev};
        delete newErrors[field];
        return newErrors;
      });
    }
  };
  
  return (
    <div className="form-section">
      <h4 className="text-lg font-medium text-gray-700 mb-3">Upload Police Check PDF</h4>
      <div className="space-y-4">
      <div className="mb-4">
        <input
          id="police-check-upload"
          type="file"
          name="policeCheck"
          accept=".pdf"
          className="hidden"
          onChange={(e) => validatePDFFile('policeCheck',e)}
          ref={policeInputRef}
        />
        
        {!formData.policeCheck ? (
          <button
            type="button"
            onClick={() => policeInputRef.current.click()}
            className="upload-button flex items-center justify-center px-4 py-2 w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg shadow hover:from-blue-600 hover:to-indigo-700 transition-all duration-200"
          >
            <span className="font-medium">Upload Police Check</span>
          </button>
        ) : (
          <div className="file-info p-3 bg-gray-50 rounded-md border border-gray-200">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <span className="file-name text-sm font-medium text-gray-700">
                  {formData.policeCheck.name}
                </span>
              </div>
              <button
                type="button"
                onClick={() => {
                  setFile('policeCheck', null);
                  // Use the existing validation function with a mock empty event
                  validatePDFFile('policeCheck', { target: { files: [] } });
              }}
                className="text-sm text-red-600 hover:text-red-800 font-medium"
              >
                Remove
              </button>
            </div>
          </div>
        )}
        
        {formErrors.policeCheck && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('policeCheck') && (
          <div className="text-sm text-red-600 mt-1">
            {formErrors.policeCheck}
          </div>
        )}
      </div>
      <div>
          <label htmlFor="police-check-issue" className="block text-sm font-medium text-gray-700 mb-1">
            Police Check Issue Date
          </label>
          <input
            type="date"
            id="police-check-issue"
            name="policeCheckIssue"
            value={formData.policeCheckIssue}
            onChange={(e) => validatePastDate('policeCheckIssue', e)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"/>
                  
          {formErrors.policeCheckIssue && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('policeCheckIssue') && (
          <div className="text-sm text-red-600 mt-1">
            {formErrors.policeCheckIssue}
          </div>
          )}
    </div>
    </div>
    </div>
    
  );
};

export default PoliceCheckSection;